import { useQuery } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

export const instPointsByAssetKey = (assetId) => ['instPointsByAsset', assetId];
export const instPointsByAssetFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL_V2}fsd/sensors/search-by-asset`, {
    params: { filters: { assetId: queryKey[1] } },
    paramsSerializer: {
      serialize: (params) => qs.stringify(params)
    },
  });

export const useInstPointsByAssetQuery = ({ assetId }) => {
  return useQuery({
    queryKey: instPointsByAssetKey(assetId),
    queryFn: instPointsByAssetFn,
    enabled: !!assetId,
    staleTime: 0,
    select: ({ data }) => data?.data || [],
  });
};
